// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-angular-js": () => import("./../src/pages/angular.js" /* webpackChunkName: "component---src-pages-angular-js" */),
  "component---src-pages-firebase-js": () => import("./../src/pages/firebase.js" /* webpackChunkName: "component---src-pages-firebase-js" */),
  "component---src-pages-gatsbyjs-js": () => import("./../src/pages/gatsbyjs.js" /* webpackChunkName: "component---src-pages-gatsbyjs-js" */),
  "component---src-pages-graphql-js": () => import("./../src/pages/graphql.js" /* webpackChunkName: "component---src-pages-graphql-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-react-js": () => import("./../src/pages/react.js" /* webpackChunkName: "component---src-pages-react-js" */),
  "component---src-pages-rxjs-js": () => import("./../src/pages/rxjs.js" /* webpackChunkName: "component---src-pages-rxjs-js" */)
}

